import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import {
  NormalButton,
  NormalDate,
  NormalTable,
  NormalInput,
  SearchInputKeyboard,
  NormalMultiSelect,
} from "component/common";
import { Toast } from "service/toast";
import _ from "lodash";
import { getCommonApi, commonCreateApi } from "redux/actions/common";
import "../style.scss";
import closeIcon from "assets/images/close.png";
import { history } from "helpers";
import download from "assets/images/reports/download.png";
// import print from "assets/images/reports/print.png";
import ReactPaginate from "react-paginate";
import moment from "moment";

export class TreatmentClass extends Component {
  state = {
    formFields: {
      projectTitle: "",
      projectDesc: "",
      status: "",
      custName: "",

      contactName: "",
      contactNumber: "",
    },
    visible: false,
    SiteSelectionOption: [],
    SiteSelection: [],
    customer: [],
    customerOption: [],
    customerList: [],
    isMounted: true,
    selectedInvoice: null,
    from_Date: new Date(),
    paymentTransactions: [],
    to_Date: new Date(),
    // scheduleOptions: [],
    reports: [],
    StaffOption: [],
    Staff: [],
    Td: [],
    TdOption: [],
    ReportTable: [],
    projectList: [],
    invoice: [],
    invoiceref: [],
    statusOption: [],
    hide: true,
    total: 0,

    showPrint: true,
    is_loading: true,
    treatmentListHeader: [],
    active: false,
    currentValue: 0,
    CollectionOutlet: [],
    perPage: 10,
    // payDate: [],
    currentPage: 1,
    isLoading: false,

    navLinks: [
      {
        to: this.props.location.pathname,
        label: "Activities",
        id: "Activities",
      },
      {
        to: this.props.location.pathname,
        label: "Quotation",
        id: "Quotation",
      },
      { to: this.props.location.pathname, label: "Purchase Order", id: "PO" },
    ],
    selectedMenu: "Activities",
    PayModeOption: [],
    PayMode: [],
  };

  handleDatePick = ({ target: { value, name } }) => {
    let { from_Date, to_Date } = this.state;

    if (name == "to_Date") {
      to_Date = value;
      this.setState({ to_Date });
    }

    if (name == "from_Date") {
      from_Date = value;
      this.setState({ from_Date });
    }
    this.setState({
      from_Date,
      to_Date,
    });
  };

  handleInvoiceRef(item) {
    this.props.getCommonApi(`receiptpdf/?sa_transacno=${item}`).then((res) => {
      console.log(res.data, "result");

      this.setState({
        invoice: res.data,
      });
      const { invoice } = this.state;
      window.open(invoice, "_blank");
    });
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
    });

    this.Selected_data();
    this.getdefaultSiteList();
    this.getdefaultStaffList();
    this.getTdList();
  }

  Selected_data() {
    this.props.getCommonApi(`listpaytable/`).then(async (res) => {
      console.log(res, "PayModeOption");
      let PayModeOption = [];
      this.setState({
        PayModeOption: res.data?.map((e) => {
          return { label: e.name, value: e.code };
        }),
      });

      console.log(PayModeOption.itemcode, "paymode");
    });
  }
  updateState = async (data) => {
    if (this.state.isMounted) this.setState(data);
  };
  onChange = (e) => {
    this.updateState({ [e.target.name]: e.target.value });
  };
  handleMultiSiteSelection = (data = []) => {
    let { SiteSelection } = this.state;
    SiteSelection = data;
    this.setState({ SiteSelection });
  };
  handleMultiPayModeSelection = (data = []) => {
    let { PayMode } = this.state;
    PayMode = data;
    this.setState({ PayMode });
  };

  getdefaultSiteList = async () => {
    let { SiteSelectionOption, SiteSelection } = this.state;
    this.props.getCommonApi(`sitelisting/`).then(async (res) => {
      console.log(res, "SiteSelectionOption");
      let SiteSelectionOption = [];
      this.setState({
        SiteSelectionOption: res.data?.map((e) => {
          return { label: e.itemdesc, value: e.itemcode };
        }),
      });

      // let { data, status } = res;
    });
  };

  handleViewReport(currentPage = 1) {
    this.setState({
      isLoading: true,
    });
    let {
      from_Date,
      to_Date,
      CollectionOutlet,
      SiteSelection,
      PayMode,
      ReportTable,
      paymentTransactions,
      payDate,
      invoiceref,
    } = this.state;
    try {
      const data = {
        from_date: moment(from_Date).format("YYYY-MM-DD"),
        to_date: moment(to_Date).format("YYYY-MM-DD"),
        report_title: "Detail",
        site_code:
          this.state.SiteSelection.length > 0
            ? this.state.SiteSelection.map((e) => e.value).join(",")
            : "",

        limit: 10,
        page: currentPage,
      };
      this.props.commonCreateApi(`treatmentdonereport/`, data).then((res) => {
        console.log(res, "hdr");
        console.log(invoiceref, " invoiceref");
        this.setState({
          CollectionOutlet: res.company_header,
          ReportTable: res.data.dataList,
          invoiceref: res.data.dataList.map((e) => e.sa_transacno),
          paymentTransactions: res.data.dataList,
          limit: res.data.pagination.total_pages,
          page: res.data.pagination.currentPage,
          // payDate: res.data.dataList[0].payDate,
        });
        // let temp = res.data.dataList[0];
        console.log(invoiceref, "invoiceref");
        console.log(this.ReportTable, "reportstable");
        console.log(this.state.paymentTransactions, "trans");
        // console.log(this.state.payDate, "tempss");
      });
      this.setState({
        isLoading: false,
        CollectionOutlet,
        ReportTable,
        invoiceref,
        paymentTransactions,
        // payDate,
      });
    } catch (e) {
      console.log(e, "topupgetcombinelog");
    }
  }

  onSubmit() {
    this.handleViewReport();
  }

  handlePageClick = (e) => {
    console.log(e.selected, "e.selected");
    this.handleViewReport(e.selected + 1);
  };
  Print = () => {
    let printContents = document.getElementById("printablediv");
    this.setState({ showPrint: false });
    window.print();
  };

  handleStaffSelection = (data = []) => {
    let { Staff } = this.state;
    Staff = data;
    this.setState({ Staff });
  };

  getdefaultStaffList = async () => {
    let { StaffOption, Staff } = this.state;
    this.props
      .getCommonApi(`empcartlist/?sales_staff=0&page=1&limit=50`)
      .then(async (res) => {
        console.log(res.data.dataList, "staffselection");
        let StaffOption = [];
        this.setState({
          StaffOption: res.data.dataList.map((e) => {
            return { label: e.emp_name, value: e.id };
          }),
        });

        console.log(StaffOption, "staffselection");

        let { data, status } = res;
      });
  };

  handleTdSelection = (data = []) => {
    let { Td } = this.state;
    Td = data;
    this.setState({ Td });
  };
  getTdList = async () => {
    let { TdOption, Td } = this.state;
    this.props
      .getCommonApi(`empcartlist/?sales_staff=0&page=1&limit=50`)
      .then(async (res) => {
        console.log(res.data.dataList, "staffselection");
        let TdOption = [];
        this.setState({
          TdOption: res.data.dataList.map((e) => {
            return { label: e.emp_name, value: e.id };
          }),
        });
        console.log(TdOption, "staffselection");
        let { data, status } = res;
      });
  };
  handleSearch = async (value) => {
    // event.persist();
    let { formFields } = this.state;
    formFields.custName = value;
    await this.setState({ formFields });
    if (!this.debouncedFn) {
      this.debouncedFn = _.debounce(async () => {
        this.search();
      }, 500);
    }
    this.debouncedFn();
  };

  handleIconSearch = async () => {
    // this.handleClick();
    let { formFields } = this.state;
    await this.setState({ visible: true });
    let data = formFields["custName"] ?? "";
    await this.search(data);
  };

  search = (searchString) => {
    let { formFields } = this.state;
    if (formFields.custName && formFields.custName.length >= 1) {
      this.props
        .getCommonApi(`custappt/?search=${formFields.custName}`)
        .then((key) => {
          let { status, data } = key;
          if (status === 200) {
            // for (let value of data) {
            //     customerList.push({ value: value.id, label: value.emp_name })
            // }
            this.setState({ customerOption: data });
          }
        });
    }
  };
  handleClick = async () => {
    let { formFields } = this.state;
    await this.setState({ visible: true });
    let data = formFields["custName"] ?? "";
    await this.search();
  };

  handleOutsideClick = (e) => {
    if (this.node != null) {
      if (this.node.contains(e.target)) {
        return;
      }
    }
    this.handleClick();
  };
  removeCustomer = (index) => {
    let { customerList } = this.state;
    this.setState((prevState) => {
      const updatedCustomerList = [...prevState.customerList];
      updatedCustomerList.splice(index, 1);
      return { customerList: updatedCustomerList };
    });
  };
  handleSelectCustomer = async (data) => {
    let { customerList, formFields, TdOption } = this.state;

    formFields["custName"] = data.cust_name;
    // this.state.customer.push(data.cust_name);
    // const selectedCustomer = {
    //   label: data.cust_name,
    //   value: data.id,
    // };
    this.handleClick();
    this.setState({
      customerList: [
        ...this.state.customerList,
        {
          label: data.cust_name,
          value: data.id,
        },
        // selectedCustomer,
        // formFields,
      ],
    });
    formFields["custName"] = "";
    // console.log(this.state.customerOption, "testing");

    // console.log(this.state.customer.push(data.cust_name), "testing");
  };

  render() {
    let { ReportTable, CollectionOutlet, payTypes, isLoading } = this.state;
    const { paymentTransactions } = this.state;

    // Grouping the payment transactions by payTypes
    const groupedData = {};
    paymentTransactions.forEach((item) => {
      const { siteName, payTypes, payDate, amt, taxes, bankCharges, total } =
        item;
      if (!groupedData[siteName]) {
        groupedData[siteName] = {};
      }
      if (!groupedData[siteName][payTypes]) {
        groupedData[siteName][payTypes] = {
          items: [],
          totalAmt: 0,
          totalTaxes: 0,
          totalBankCharges: 0,
          total: 0,
        };
      }
      groupedData[siteName][payTypes].items.push(item);
      groupedData[siteName][payTypes].totalAmt += parseFloat(amt);
      groupedData[siteName][payTypes].totalTaxes += parseFloat(taxes);
      groupedData[siteName][payTypes].totalBankCharges +=
        parseFloat(bankCharges) || 0;
      groupedData[siteName][payTypes].total += parseFloat(total);
    });
    const data = paymentTransactions.reduce((result, item) => {
      if (!result[item.custName]) {
        result[item.custName] = [];
      }
      result[item.custName].push(item);
      return result;
    }, {});
    // Rendering the grouped data
    const siteNameKeys = Object.keys(groupedData);
    let { tokenDetails } = this.props;
    let { autotdforalacarte } = tokenDetails;

    ///////////////////////////////

    const groupedTransactions = paymentTransactions.reduce(
      (result, transaction) => {
        const { custName, unitValue, share_amt, SerPt, duration } = transaction;

        if (!result[custName]) {
          result[custName] = {
            transactions: [],
            total: {
              unitValue: 0,
              share_amt: 0,
              SerPt: 0,
              duration: 0,
            },
          };
        }

        result[custName].transactions.push(transaction);
        result[custName].total.unitValue += parseFloat(unitValue);
        result[custName].total.share_amt += parseFloat(share_amt);
        result[custName].total.SerPt += parseFloat(SerPt);
        result[custName].total.duration += parseInt(duration);

        return result;
      },
      {}
    );

    const grandTotal = Object.values(groupedTransactions).reduce(
      (totals, customer) => {
        totals.unitValue += customer.total.unitValue;
        totals.share_amt += customer.total.share_amt;
        totals.SerPt += customer.total.SerPt;
        totals.duration += customer.total.duration;
        return totals;
      },
      { unitValue: 0, share_amt: 0, SerPt: 0, duration: 0 }
    );

    return (
      <div className="col-12 treatmentdone">
        <div className="container-fluid pb-5 bg-white px-md-5 my-3">
          <div className="py-5 ">
            <div className="col-md-12">
              <p className="fs-16">
                <span className="font-weight-bold px-1 ">HOME/REPORTS/</span>
                TREAMENT DONE
              </p>
              <h1 className="my-4 reports-heading">Treatment Done</h1>
            </div>

            <div className=" my-3">
              <div className="row">
                <div className="mt-3 col-lg-3  col-sm-6 ">
                  <span>{"From Date*"}</span>
                  <div className="input-group">
                    <NormalDate
                      value={this.state.from_Date}
                      name="from_Date"
                      showYearDropdown={true}
                      onChange={this.handleDatePick}
                      dateFormat="dd/MM/yyyy "
                    />
                  </div>
                </div>
                <div className="mt-3  col-lg-3  col-sm-6 ">
                  <span>{"To Date*"}</span>
                  <div className="input-group">
                    <NormalDate
                      value={this.state.to_Date}
                      name="to_Date"
                      showYearDropdown={true}
                      dateFormat="dd/MM/yyyy"
                      type="date"
                      onChange={this.handleDatePick}
                    />
                  </div>
                </div>
                <div className="mt-3  col-lg-3  col-sm-6 ">
                  <span>{"Site Selection"}</span>
                  <NormalMultiSelect
                    handleMultiSelect={this.handleMultiSiteSelection}
                    options={this.state.SiteSelectionOption}
                    value={this.state.SiteSelection}
                    name="SiteSelection"
                  />
                </div>

                <div className="mt-3  col-lg-3  col-sm-6 ">
                  <span className="text-black">{"Staff"}</span>

                  <NormalMultiSelect
                    handleMultiSelect={this.handleStaffSelection}
                    options={this.state.StaffOption}
                    value={this.state.Staff}
                    name="Staff"
                  />
                </div>
                <div className="mt-3  col-lg-3  col-sm-6 ">
                  <span className="text-black">
                    {"Staff done the TD with someone else"}
                  </span>

                  <NormalMultiSelect
                    handleMultiSelect={this.handleTdSelection}
                    options={this.state.TdOption}
                    value={this.state.Td}
                    name="Td"
                  />
                </div>
                <div className="mt-3  col-lg-6  col-sm-6 ">
                  <span className="text-black">{"Customer"}</span>
                  {this.props.tokenDetails.autotdforalacarte ? (
                    <SearchInputKeyboard
                      onRef={(ref) => (this.childDetailsInput = ref)}
                      onChangeTextInput={(e) => this.handleSearch(e)}
                      handleIconSearch={() => {
                        this.handleClick();
                      }}
                      handleHideModal={(val) => this.setState({ visible: val })}
                      focusValue={"customerName"}
                      placeHolderText={"Search Customer.."}
                      keyboardModalValue
                      positionAlignmentLeft=" treatmentKeyboardLeft"
                    />
                  ) : (
                    <NormalInput
                      placeholder="Search Customer.."
                      value={this.state.formFields.custName}
                      name="custName"
                      onChange={(e) => this.handleSearch(e.target.value)}
                      iconsVisible
                      onClickIcon={() => {
                        this.handleIconSearch();
                      }}
                    />
                  )}
                  {this.state.visible ? (
                    <div className="customerSearch-block">
                      <div className="closeIconParent">
                        <img
                          onClick={() => this.setState({ visible: false })}
                          className="close cursor-pointer close-flexEnd"
                          src={closeIcon}
                          alt=""
                        />
                      </div>
                      <div className="d-flex mt-4 table table-header w-100 m-0">
                        <div className="col-2">{"Name"}</div>
                        <div className="col-2">{"Phone"}</div>
                        <div className="col-1">{"Site"}</div>
                        <div className="col-2">{"Cust Code"}</div>
                        <div className="col-2">{"Reference"}</div>
                        <div className="col-3">{"Email"}</div>
                        <div className="col-1 d-none">{"NRIC"}</div>
                      </div>
                      <div className="response-table w-100">
                        {this.state.customerOption.length > 0 ? (
                          this.state.customerOption.map((item, index) => {
                            return (
                              <div
                                className={`row m-0 table-body w-100 border py-2 ${
                                  !item.isoutlet_resrict && "rowDisable"
                                }`}
                                onClick={() => {
                                  !item.isoutlet_resrict
                                    ? Toast({
                                        type: "error",
                                        message:
                                          "This customer is not inside ur outlet, Please request this customer",
                                      })
                                    : this.handleSelectCustomer(item);
                                }}
                                key={index}
                              >
                                <div className="col-2">{item.cust_name}</div>
                                <div className="col-2">{item.cust_phone2}</div>
                                <div className="col-1">{item.or_key}</div>
                                <div className="col-2">{item.cust_code}</div>
                                <div className="col-2">{item.cust_refer}</div>
                                <div className="col-3">{item.cust_email}</div>
                                <div className="col-1 d-none">
                                  {item.cust_nric}
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <div className="text-center w-100">
                            {"No Data are available"}
                          </div>
                        )}
                      </div>
                    </div>
                  ) : null}
                </div>
                <div className="my-4 pt-1 col-md-3 col-12 border p-1 mt-3">
                  <div className="row">
                    <div className="selected-customers my-1 mx-2">
                      <div className="row testing w-100">
                        {this.state.customerList.map((customer, index) => (
                          <div class="d-flex shrink flex-row flex-md-wrap align-content-start ">
                            <div>
                              {" "}
                              <div
                                key={index}
                                className="selected-customer my-1 mx-1"
                              >
                                <span class="custom-pill mx-2">
                                  <div className="d-flex">
                                    {" "}
                                    <span className="customer-name">
                                      {customer.label}
                                    </span>
                                    <button
                                      type="button"
                                      aria-label="Close"
                                      className="remove-customer"
                                      onClick={() => this.removeCustomer(index)}
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  {/* <div className="customer-box">
                    {this.state.customerList.map((customer, index) => (
                      <span key={index} className="customer-item">
                        {customer.label}
                      </span>
                    ))}
                  </div> */}
                </div>
                <div className="my-4 pt-3 col-md-3 col-12">
                  <NormalButton
                    mainbg={true}
                    label={"View Report"}
                    onClick={() => this.onSubmit()}
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            {isLoading ? (
              <tr>
                {/* <td colSpan="8">
                  <div class="d-flex mt-5 align-items-center justify-content-center">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                </td> */}
                no data
              </tr>
            ) : ReportTable && ReportTable.length > 0 ? (
              <div className="report">
                <div className=" border px-md-5 py-4 mx-md-4">
                  <div>
                    <div className="row border-md my-3 p-1">
                      <div className="col-lg-2 col-sm-5">
                        <ReactPaginate
                          previousLabel={"<"}
                          nextLabel={">"}
                          breakLabel={"..."}
                          breakClassName={"break-me"}
                          pageCount={this.state.pageCount}
                          marginPagesDisplayed={1}
                          pageRangeDisplayed={1}
                          onPageChange={(event) => this.handlePageClick(event)}
                          containerClassName={"pagination"}
                          subContainerClassName={"pages pagination"}
                          activeClassName={"active"}
                        />
                      </div>
                      <div className="col-lg-2 col-sm-2  border-left border-right text-center mt-2">
                        <button
                          id="print"
                          onClick={() => this.printPDF()}
                          className="pointer bg-white border-0"
                        >
                          <p>
                            <img
                              src={download}
                              alt="download"
                              className="mx-1"
                            />
                          </p>{" "}
                        </button>
                      </div>
                      <div className="col-lg-2 col-sm-2 mt-1 col-6">
                        {" "}
                        <div>
                          <NormalButton
                            buttonClass={"print"}
                            mainbg={true}
                            label="print"
                            className="pointer bg-white border-0"
                            onClick={() =>
                              history.push({
                                pathname:
                                  "/admin/collectionbyoutlet/printreport",
                                state: {
                                  CollectionOutlet: this.state.CollectionOutlet,
                                  paymentTransactions:
                                    this.state.paymentTransactions,
                                  payDate: this.state.payDate,
                                  // from_date: moment(
                                  //   this.state.from_Date
                                  // ).format("YYYY-MM-DD"),

                                  // to_date: moment(this.state.to_Date).format(
                                  //   "YYYY-MM-DD"
                                  // ),

                                  // report_title: "Collection By Outlet",

                                  // site_code: this.state.SiteSelection.map(
                                  //   (e) => e.value
                                  // ).join(","),

                                  // pay_code: this.state.PayMode.map(
                                  //   (e) => e.value
                                  // ).join(","),

                                  // limit: 10,

                                  // page: this.state.currentPage,
                                },
                              })
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {isLoading ? (
                      <tr>
                        <td colSpan="8">
                          <div class="d-flex mt-5 align-items-center justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <div id="printablediv">
                        <h3 className="reports-heading my-5 p-3 d-flex flex-wrap">
                          {CollectionOutlet.title}
                          <span className="mx-2">|</span>
                          <span className="mx-2">
                            {CollectionOutlet.comp_title3}
                          </span>
                          <span className="mx-2">|</span>
                          {CollectionOutlet.comp_title4}
                          <span className="mx-2">|</span>
                        </h3>
                        <div className="row p-2">
                          <div className="col-lg-6 col-12">
                            <div className="row">
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Report Title</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {/* {CollectionOutlet?.report_title} */}{" "}
                                  Treatment Done Report
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">From Date</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.from_date}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Printed by</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.print_by}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Site</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.site}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-12">
                            <div className="row ">
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Outlet</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.outlet}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">To Date</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.to_date}
                                </p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-label">Print Time</p>
                              </div>
                              <div className="col-md-6 col-6 my-2">
                                <p className="report-details">
                                  {CollectionOutlet.print_time}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div>
                            <div>
                              {Object.entries(groupedTransactions).map(
                                ([custName, customer]) => (
                                  <div key={custName}>
                                    <h6 className="mt-5 mb-4">
                                      {" "}
                                      customer name:{custName}
                                    </h6>
                                    <NormalTable
                                      headerDetails={
                                        this.state.treatmentListHeader
                                      }
                                    >
                                      <thead className="text-nowrap">
                                        <tr>
                                          <th className="align-items-center justify-content-center">
                                            STAFF NAME
                                          </th>{" "}
                                          <th className="align-items-center justify-content-center">
                                            CUSTOMER
                                          </th>
                                          <th className="align-items-center justify-content-center">
                                            S.NO
                                          </th>
                                          <th className="align-items-center justify-content-center">
                                            DATE
                                          </th>
                                          <th className="text-center">
                                            SALES TRANS
                                          </th>
                                          <th className="text-center">
                                            #TD TRANS
                                          </th>
                                          <th className="text-center">
                                            ITEM NAME
                                          </th>
                                          <th className="text-center">
                                            UNIT VALUE
                                          </th>
                                          <th className="text-center">
                                            SHARE AMOUNT
                                          </th>
                                          <th className="text-center">
                                            WORK POINT
                                          </th>
                                          <th className="text-center">
                                            DURATION
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {customer.transactions.map(
                                          (transaction) => (
                                            <tr key={transaction.invoiceRef}>
                                              <td>{transaction.therapists}</td>
                                              <td>{transaction.custName}</td>
                                              <td>
                                                {transaction.numTherapists}
                                              </td>
                                              <td>{transaction.invoiceDate}</td>
                                              <td>{transaction.invoiceRef}</td>
                                              <td>{transaction.usageRef}</td>
                                              <td>{transaction.itemName}</td>
                                              <td>{transaction.unitValue}</td>
                                              <td>{transaction.share_amt}</td>
                                              <td>{transaction.SerPt}</td>
                                              <td>{transaction.duration}</td>
                                            </tr>
                                          )
                                        )}
                                        <tr>
                                          <td colSpan="7">Total:</td>
                                          <td>{customer.total.unitValue}</td>
                                          <td>{customer.total.share_amt}</td>
                                          <td>{customer.total.SerPt}</td>
                                          <td>{customer.total.duration}</td>
                                        </tr>
                                      </tbody>
                                    </NormalTable>
                                  </div>
                                )
                              )}

                              <div>
                                <NormalTable
                                  headerDetails={this.state.treatmentListHeader}
                                >
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th>UNIT VALUE</th>
                                      <th>SHARE AMOUNT</th>
                                      <th>WORK POINT</th>
                                      <th>DURATION</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td colSpan="7" className="fw-700">
                                        Grand Total
                                      </td>
                                      <td>{grandTotal.unitValue}</td>
                                      <td>{grandTotal.share_amt}</td>
                                      <td>{grandTotal.SerPt}</td>
                                      <td>{grandTotal.duration}</td>
                                    </tr>
                                  </tbody>
                                </NormalTable>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <td colSpan="8">
                <div class="d-flex mt-5 align-items-center justify-content-center">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCommonApi, commonCreateApi }, dispatch);
};

export const Treatment = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(TreatmentClass)
);
